// extracted by mini-css-extract-plugin
export default {"shop":"OtherTest_shop__zbKKI","othertest_input":"OtherTest_othertest_input__A2s8K","othertest_go":"OtherTest_othertest_go__LKlMb"};